import PropTypes from "prop-types";
import React from "react";
import { Container, Row } from "reactstrap";
import { withTranslation } from "react-i18next";
import ReportListLocationBasedView from "./ReportListLocationBasedView";

const Reports = props => {
  document.title = "Reports | CurbDash";

  return (
    <React.Fragment>
      <div className="page-content" style={{ marginTop: -70, backgroundColor: "rgb(38, 37, 35)" }}>
        <Container fluid>
          <Row>
            <ReportListLocationBasedView />
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

Reports.propTypes = {
  t: PropTypes.any,
  chartsData: PropTypes.any,
  onGetChartsData: PropTypes.func,
};

export default withTranslation()(Reports);
